/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_4_AInputs */

const en_vc_onl_faq_4_a = /** @type {(inputs: Vc_Onl_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The drawing features are the same. The desktop app starts faster, handles large files better, works fully offline and includes the MCP server for AI agents and the command-line tool.`)
};

const zh_vc_onl_faq_4_a = /** @type {(inputs: Vc_Onl_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绘图功能完全一样。桌面版启动更快、处理大文件更好、完全离线可用，还带有供 AI 助手使用的 MCP server 和命令行工具。`)
};

/**
* | output |
* | --- |
* | "The drawing features are the same. The desktop app starts faster, handles large files better, works fully offline and includes the MCP server for AI agents a..." |
*
* @param {Vc_Onl_Faq_4_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_4_a = /** @type {((inputs?: Vc_Onl_Faq_4_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_4_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_4_a(inputs)
	return zh_vc_onl_faq_4_a(inputs)
});
export { vc_onl_faq_4_a as "vc.onl.faq.4.a" }